require('./polyfill');
require('./functions');
import zoomImage, {getCookie, setCookie} from './../libs/lightweight-zoomer/js/zoom.js';

document.addEventListener('DOMContentLoaded', function () {
    require('./teachers');
    require('./reviews');
    require('./blog');
    require('./faq');
    require('./navigation');
    require('./select-format');
    require('./advantages');
    require('./bonuses');
    require('./footer');
    require('./purposes');
    require('./subscribe');
    require('./features');
    require('./help-select');
    require('./prices-slider');
    require('./anons');
    require('./speakers');
    require('./learning-formats');
    require('./corporate-examples');
    require('./recommend-letters');
    require('./individual-prices');
    require('./schedule');
    require('./events');
    require('./prices-group');
    require('./test');
    require('./event');
    require('./docs');
    require('./news');
    require('./video');
    require('./need-if');
    require('./course');
    require('./danone');
    require('./french');

    if(document.getElementById('prices-app')){
        new Vue({
            el: '#prices-app',
            template: `<prices></prices>`,
            components: {
                prices: require('../components/prices/Prices').default,
            },
        });
    }

    $('.open-record-form-js').click(function (e) {
        e.preventDefault();
        openRecordFormModal({
            purpose: this.getAttribute('data-purpose'),
            title: this.getAttribute('data-title') || 'Заказать консультацию',
            withLanguage: !!this.getAttribute('data-with-lang'),
            withoutPhoneMask: !!this.getAttribute('data-no-phone-mask'),
            withoutPrivacyLinks: !!this.getAttribute('data-without-privacy-links'),
            namePlaceholder: this.getAttribute('data-name-placeholder') || 'Ваше имя*',
        });
    });

    $('.open-contact-form-js').click(function (e) {
        e.preventDefault();
        openRecordFormModal({
            title: 'Обратная связь',
            purpose: this.getAttribute('data-purpose'),
        });
    });


    document.querySelectorAll('.record-form-js').forEach(form => {
        initRecordForm(form);
    });

    $(document).on('click', '.image-zoomable-js', function () {
        let modal = new tingle.modal({
            closeLabel: '',
            cssClass: ['image-modal-popup'],
            onClose(){
                modal.destroy();
            },

            onOpen(){
                let zoomBlock = modal.modalBox.querySelector('.light-zoom-js');
                zoomImage(zoomBlock);
            },
        });

        let url = this.getAttribute('data-url');
        if(!url){
            url = this.getAttribute('src');
        }
        let webpUrl = this.getAttribute('data-url-webp');
        if(document.documentElement.classList.contains('webp-support') && webpUrl)
            url = webpUrl;

        let content = `
    <div class="light-zoom light-zoom-js">
        <img src="${url}" class="modal-image">
    </div>`;

        modal.setContent(content);
        modal.open();
    });

    $('.smooth-scroll-js').click(function (e) {
        let link = e.target;
        if(link.tagName !== 'A')
            link = link.querySelector('a');

        let id = link.getAttribute('href').replace(/.*#/, '');
        let scrollToBlock = document.getElementById(id);
        if(scrollToBlock){
            e.preventDefault();
            $('html,body').animate({scrollTop: scrollToBlock.offsetTop - 120});
            $('.top__menu-list').slideUp();
            $('#top-overlay-js').removeClass('top-overlay--show');
            $('#top-menu__hamburger-js').removeClass('active');
        }
    });



    //Биндим клик по кнопкам записи на курс учителя
    $(document).on('click', '.entry-teacher-course-js', function(e) {
        e.preventDefault();
        let title = $(this).data('title');
        let fio = $(this).data('fio');
        title = `Запись на курс ${title} (${fio})`;
        openRecordFormModal({title});
    });

    $('.visually-impaired-js').click(function () {
        if(window.getCookie('visually-impaired'))
            return;

        window.setCookie('visually-impaired', 1);
        document.location.reload();
    });
});

window.isTouch = "ontouchstart" in window || navigator.msMaxTouchPoints;